import Contract from '../../utils/contract'

const contract = new Contract()

export default [
  {
    title: 'email',
    type: 'email',
    mask: [
      {
        mask: '',
        startsWith: ''
      }
    ],
    pattern:
      /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
    fn: (value, message) => {
      contract.clear()
      contract.isEmail(value, message)
      return {
        hasError: !contract.isValid(),
        message: message
      }
    }
  },
  {
    title: 'cep',
    type: 'zipcode',
    mask: [
      {
        mask: '',
        startsWith: ''
      },
      {
        mask: '00000-000',
        lazy: false
      }
    ],
    pattern: /^\d{5} - \d{3}$/,

    fn: (value, message) => {
      contract.clear()
      contract.isCep(value, message)
      return {
        hasError: !contract.isValid(),
        message: message
      }
    }
  },
  {
    title: 'cpf',
    type: 'text',
    mask: [
      {
        mask: '',
        startsWith: ''
      },
      {
        mask: '000.000.000-00',
        lazy: false
      }
    ],
    pattern: /^\d{3}\.\d{3}.\d{3}-\d{2}$/,
    fn: (value, message) => {
      contract.clear()
      contract.validateCpf(value, message)
      return {
        hasError: !contract.isValid(),
        message: message
      }
    }
  },
  {
    title: 'cnpj',
    pattern: /^\d{2}\.\d{3}.\d{3}\/\d{4}-\d{2}$/,
    value: /_| |-|\./g,
    mask: [
      {
        mask: '',
        startsWith: ''
      },
      {
        mask: '00.000.000/0000-00',
        lazy: false
      }
    ],
    fn: (value, message) => {
      contract.clear()
      contract.validateCNPJ(value, message)
      return {
        hasError: !contract.isValid(),
        message: message
      }
    }
  },
  {
    title: 'cpf-cnpj',
    pattern: /^(\d{3}\.\d{3}.\d{3}-\d{2})|(\d{2}\.\d{3}.\d{3}\/\d{4}-\d{2})$/,
    value: /_| |-|\./g,
    mask: [
      {
        mask: '',
        startsWith: ''
      },
      {
        mask: '000.000.000-00',
        lazy: false
      },
      {
        mask: '00.000.000/0000-00',
        lazy: false
      },
      {
        mask: '',
        startsWith: ''
      }
    ],
    fn: (value, message) => {
      contract.clear()
      value.replace(/\D/g, '').length <= 11
        ? contract.validateCpf(value, message)
        : contract.validateCNPJ(value, message)

      return {
        hasError: !contract.isValid(),
        message: message
      }
    }
  },
  {
    title: 'cpfCnpj',
    pattern: /^(\d{3}\.\d{3}.\d{3}-\d{2})|(\d{2}\.\d{3}.\d{3}\/\d{4}-\d{2})$/,
    value: /_| |-|\./g,
    mask: [
      {
        mask: '',
        startsWith: ''
      },
      {
        mask: '000.000.000-00',
        lazy: false
      },
      {
        mask: '00.000.000/0000-00',
        lazy: false
      },
      {
        mask: '',
        startsWith: ''
      }
    ],
    fn: (value, message) => {
      contract.clear()
      value.replace(/\D/g, '').length <= 11
        ? contract.validateCpf(value, message)
        : contract.validateCNPJ(value, message)

      return {
        hasError: !contract.isValid(),
        message: message
      }
    }
  },
  {
    title: 'cpfEmailUser',
    type: 'email',
    hasDynamicValue: true,
    mask: [
      // {
      //   mask: '',
      //   startsWith: ''
      // },
      {
        mask: '000000',
        lazy: true,
      },
      {
        mask: '000.000.000-00',
        lazy: true,
      },
      {
        mask: /^\S*@?\S*$/,
        lazy: true
      }
    ],
    fn: (value, message) => {
      contract.clear()
      let type;
      const validateValue = value.replace(/\D/g, '');
      const pattern = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
      const isEmail  =  pattern.test(value);
      
      if(isEmail) {
        contract.isEmail(value, message)
        type = 'email'
      } else if (/[a-z]/i.test(value) && /^[^<@>]+$/i.test(value)) return true; // Validate user;
      else if (validateValue.length <= 11) {
        contract.validateCpf(validateValue, message)
        type = 'cpf'
      } else {
        contract.isEmail(value, message)
        type = 'email'
      }

      return {
        hasError: !contract.isValid(),
        message: message
      }
    }
  },
  {
    title: 'cpfCnpjEmailUser',
    hasDynamicValue: true,
    type: 'email',
    mask: [
      {
        mask: '',
        startsWith: ''
      },
      {
        mask: '000000',
        lazy: true,
      },
      {
        mask: '000.000.000-00',
        lazy: true,
      },
      {
        mask: '00.000.000/0000-00',
        lazy: true
      },
      {
        mask: /^\S*@?\S*$/
      }
    ],
    fn: (value, message) => {
      contract.clear()
      let type;
      const validateValue = value.replace(/\D/g, '');
      const pattern = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
      const isEmail  =  pattern.test(value);
      
      if(isEmail) {
        contract.isEmail(value, message)
        type = 'email'
      } else if (/[a-z]/i.test(value) && /^[^<@>]+$/i.test(value)) return true; // Validate user;
      else if (validateValue.length <= 11) {
        contract.validateCpf(validateValue, message)
        type = 'cpf'
      } else if (validateValue.length > 11) {
        contract.validateCNPJ(validateValue, message)
        type = 'cnpj'
      } else {
        contract.isEmail(value, message)
        type = 'email'
      }

      return {
        hasError: !contract.isValid(),
        message: message
      }
    }
  },
  {
    title: 'phone',
    type: 'tel',
    pattern: /(?:\+?55\s?)?(?:\(?\d{2}\)?[-\s]?)?\d{4,5}[-\s]?\d{4}/g,
    mask: [
      {
        mask: '',
        startsWith: ''
      },
      {
        mask: '(00) 0000-0000',
        lazy: false
      },
      {
        mask: '(00) 0 0000-0000',
        lazy: false
      }
    ],
    fn: (value, message) => {
      contract.clear()
      contract.isPhone(value, message)
      return {
        hasError: !contract.isValid(),
        message: message
      }
    }
  },
  {
    title: 'phoneMobile',
    type: 'tel',
    pattern: /(?:\+?55\s?)?(?:\(?\d{2}\)?[-\s]?)?\d{4,5}[-\s]?\d{4}/g,
    mask: [
      {
        mask: '',
        startsWith: ''
      },
      {
        mask: '(00) 0 0000 0000',
        lazy: false
      }
    ],
    fn: (value, message) => {
      contract.clear()
      contract.isPhone(value, message)
      return {
        hasError: !contract.isValid(),
        message: message
      }
    }
  },
  {
    title: 'phoneFixed',
    type: 'tel',
    pattern: '',
    mask: [
      {
        mask: '',
        startsWith: ''
      },
      {
        mask: '(00) 0000 - 0000',
        lazy: false
      }
    ],
    fn: (value, message) => {
      contract.clear()
      contract.isPhone(value, message)
      return {
        hasError: !contract.isValid(),
        message: message
      }
    }
  },
  {
    title: 'text',
    type: 'text',
    pattern: ''
  },
  {
    title: 'number',
    pattern: '',
    type: 'number'
  },
  {
    title: 'password',
    type: 'password',
    pattern: '',
    icons: ['mdn-Icon-ocultar', 'mdn-Icon-exibir']
  },
  {
    title: 'search',
    pattern: '',
    type: 'search'
  },
  {
    title: 'action',
    type: 'email',
    icons: 'mdn-Icon-direita',
    pattern:
      /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
  },
  {
    title: 'textarea',
    pattern: ''
  },
  {
    tag: 'input',
    title: 'date',
    pattern: ''
  },
  {
    title: 'select',
    pattern: '',
    type: 'select'
  }
]
